import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SurveyCard from '../../components/cards/FormCard';
import SurveyListPageSkeleton from '../../components/skeletons/FormListPageSkeleton';
import DataListContainer from '../../components/layout/DataListContainer';
import PageLayout from '../../components/layout/PageLayout';
import CustomDropdown from '../../components/ui/CustomDropdown';

const AllForms = () => {
  const navigate = useNavigate();
  const { forms, status } = useSelector(state => state.forms);

  const [selectedProjectId, setSelectedProjectId] = useState('all');

  const projectOptions = useMemo(() => {
    const projectsMap = new Map();
    forms.forEach(form => {
      if (form.project_id && form.project?.name) {
        projectsMap.set(form.project_id, form.project.name);
      }
    });

    const options = [{ value: 'all', label: 'All Projects' }];
    projectsMap.forEach((name, id) => {
      options.push({ value: id, label: name });
    });
    return options;
  }, [forms]);

  const allFormsSorted = useMemo(() => {
    let filtered = forms;
    if (selectedProjectId !== 'all') {
      filtered = filtered.filter(f => f.project_id === selectedProjectId);
    }
    return [...filtered].sort((a, b) => new Date(b.updated_at || b.created_at) - new Date(a.updated_at || a.created_at));
  }, [forms, selectedProjectId]);
  
  const handleFillForm = formId => navigate(`/forms/fill/${formId}`);

  const isLoading = status === 'loading' && forms.length === 0;

  return (
    <PageLayout title="All Forms" showBackButton showStatus>
      <div className="pb-4">
        <CustomDropdown
          options={projectOptions}
          value={selectedProjectId}
          onChange={setSelectedProjectId}
          placeholder="Filter by Project"
        />
      </div>
      <DataListContainer
        isLoading={isLoading}
        data={allFormsSorted}
        skeletonComponent={<SurveyListPageSkeleton />}
        emptyStateProps={{
          title: "No Forms Available",
          message: "New forms assigned to you will appear here."
        }}
      >
        <div className="grid grid-cols-1 gap-6">
          {allFormsSorted.map(form => (
            <SurveyCard
              key={form.id}
              title={form.title || form.name}
              description={form.description}
              projectId={form.project_id}
              projectName={form.project?.name}
              status={form.status}
              submissionsExists={form.submissions_exists}
              page="forms"
              onAction={() => handleFillForm(form.id)}
            />
          ))}
        </div>
      </DataListContainer>
    </PageLayout>
  );
};

export default AllForms;